<template>
    <div>
        <!-- Form -->
        <b-card no-body>
            <b-card-body>
                <b-row>
                    <b-col cols="12">
                        <validation-observer ref="dataForm" #default="{ invalid }">
                            <b-form ref="form" @submit.stop.prevent="">
                                <b-row>
                                    <b-col cols="12" md="6">
                                        <b-row>
                                            <b-col cols="12" md="6">
                                                <b-form-group label-for="name" label="Printer Name">
                                                    <validation-provider #default="{ errors }" name="name" rules="">
                                                        <b-form-input
                                                            id="name"
                                                            name="name"
                                                            v-model="printer.name"
                                                            :state="errors.length > 0 ? false : null"
                                                            size="sm"
                                                        />
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                        <small class="text-danger" v-if="serverErrors && serverErrors.name">{{ serverErrors.name[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>

                                            <b-col cols="12" md="6">
                                                <b-form-group label-for="model" label="Model">
                                                    <validation-provider #default="{ errors }" name="model" rules="">
                                                        <b-form-input
                                                            id="model"
                                                            name="model"
                                                            v-model="printer.model"
                                                            :state="errors.length > 0 ? false : null"
                                                            size="sm"
                                                        />
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                        <small class="text-danger" v-if="serverErrors && serverErrors.model">{{ serverErrors.model[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>

                                        <b-row>
                                            <b-col cols="12" md="6">
                                                <b-form-group label-for="address" label="IP Address">
                                                    <validation-provider #default="{ errors }" name="address" rules="">
                                                        <b-form-input
                                                            id="address"
                                                            name="address"
                                                            v-model="printer.address"
                                                            :state="errors.length > 0 ? false : null"
                                                            size="sm"
                                                        />
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                        <small class="text-danger" v-if="serverErrors && serverErrors.address">{{ serverErrors.address[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" md="6" class="pt-0">
                                                <b-form-checkbox
                                                    v-model="printer.forMarket"
                                                    class="custom-control-success mb-1"
                                                >
                                                    Dot Matrix
                                                </b-form-checkbox>

                                                <b-form-checkbox
                                                    v-model="printer.forDocument"
                                                    class="custom-control-success"
                                                    :value="false"
                                                >
                                                    For Online Tickets
                                                </b-form-checkbox>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col cols="12" md="12">
                                        <h6>Assigned Station</h6>
                                        <hr />

                                        <b-row>
                                            <b-col cols="12" :md="parseInt(12 / stations.length)" v-for="station in stations" :key="station.id">
                                                <b-form-checkbox
                                                    v-model="printer.station_type"
                                                    :value="station.station_type"
                                                    class="custom-control-success"
                                                    @change="changeStationType()"
                                                >
                                                    {{ station.label }}
                                                </b-form-checkbox>
                                            </b-col>
                                        </b-row>

                                        <b-row v-if="printer.station_type !== 0">
                                            <b-col cols="12">
                                                <location-filters
                                                    size="sm"
                                                    align="horizontal"
                                                    @filter="changeFilters"
                                                />
                                            </b-col>
                                        </b-row>

                                        <b-row v-if="printer.station_type > 1">
                                            <b-col cols="12" md="6" v-if="printer.station_type === 2 || printer.station_type === 4">
                                                <b-form-group label-for="market_id" label="Market Center" style="cursor: pointer" v-if="printer.station_type === 2">
                                                    <validation-provider #default="{ errors }" name="station_id" rules="">
                                                        <b-form-select
                                                            size="sm" 
                                                            id="market_id"
                                                            name="market_id"
                                                            v-model="printer.station_id"
                                                            :state="errors.length > 0 ? false : null"
                                                        >
                                                            <b-form-select-option :value="null">Select...</b-form-select-option>
                                                            <b-form-select-option v-for="market in markets" :key="market.id" :value="market.id">
                                                                {{ market.name.trim().toUpperCase() }}
                                                            </b-form-select-option>
                                                        </b-form-select>
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                        <small class="text-danger" v-if="serverErrors && serverErrors.station_id">{{ serverErrors.station_id[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>

                                                <b-form-group label-for="market_id" label="Market Center" style="cursor: pointer" v-if="printer.station_type === 4">
                                                    <validation-provider #default="{ errors }" name="station_id" rules="">
                                                        <b-form-select
                                                            size="sm" 
                                                            id="market_id"
                                                            name="market_id"
                                                            v-model="printer.market_id"
                                                            :state="errors.length > 0 ? false : null"
                                                            @change="changeMarket()"
                                                        >
                                                            <b-form-select-option :value="null">Select...</b-form-select-option>
                                                            <b-form-select-option v-for="market in markets" :key="market.id" :value="market.id">
                                                                {{ market.name.trim().toUpperCase() }}
                                                            </b-form-select-option>
                                                        </b-form-select>
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                        <small class="text-danger" v-if="serverErrors && serverErrors.station_id">{{ serverErrors.station_id[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>

                                            <b-col cols="12" md="6" v-if="printer.station_type === 4">
                                                <b-form-group label-for="line_id" label="Line" style="cursor: pointer">
                                                    <validation-provider #default="{ errors }" name="station_id" rules="">
                                                        <b-form-select
                                                            size="sm" 
                                                            id="line_id"
                                                            name="line_id"
                                                            v-model="printer.station_id"
                                                            :state="errors.length > 0 ? false : null"
                                                        >
                                                            <b-form-select-option :value="null">Select...</b-form-select-option>
                                                            <b-form-select-option v-for="line in lines" :key="line.id" :value="line.id">
                                                                {{ line.name.trim().toUpperCase() }}
                                                            </b-form-select-option>
                                                        </b-form-select>
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                        <small class="text-danger" v-if="serverErrors && serverErrors.station_id">{{ serverErrors.station_id[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>

                                            <b-col cols="12" md="6" v-if="printer.station_type === 3">
                                                <b-form-group label-for="warehouse_id" label="Warehouse" style="cursor: pointer">
                                                    <validation-provider #default="{ errors }" name="station_id" rules="">
                                                        <b-form-select
                                                            size="sm" 
                                                            id="warehouse_id"
                                                            name="warehouse_id"
                                                            v-model="printer.station_id"
                                                            :state="errors.length > 0 ? false : null"
                                                        >
                                                            <b-form-select-option :value="null">Select...</b-form-select-option>
                                                            <b-form-select-option v-for="warehouse in warehouses" :key="warehouse.id" :value="warehouse.id">
                                                                {{ warehouse.name.trim().toUpperCase() }}
                                                            </b-form-select-option>
                                                        </b-form-select>
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                        <small class="text-danger" v-if="serverErrors && serverErrors.station_id">{{ serverErrors.station_id[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col cols="6" class="d-flex d-flex-contect-start" style="padding-top:28px;">
                                        <b-button
                                            size="sm"
                                            variant="primary"
                                            @click="submit()"
                                            class="mr-1"
                                        >
                                            <b-spinner small class="mr-1" label="Small Spinner" v-if="saving" />
                                            <span v-if="!saving">Save</span>
                                            <span v-if="saving">Saving...</span>
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="outline-secondary"
                                            @click="resetForm()"
                                        >
                                            Clear
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </validation-observer>
                    </b-col>
                </b-row>
            </b-card-body>
            <!-- <b-card-body>{{ printer }}</b-card-body> -->
        </b-card>
        <!-- ./Form -->

        <!-- Table Container Card -->
        <b-card no-body class="mb-0">
            <div class="m-2">
                <!-- Table Top -->
                <b-row>
                    <!-- Per Page -->
                    <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                        <label>Show</label>
                        <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="perPageOptions" :clearable="false"
                            class="per-page-selector d-inline-block mx-50 select-size-sm" />
                        <label>entries</label>
                    </b-col>
                    <!-- ./Per Page -->

                    <!-- Search -->
                    <b-col cols="12" md="6">
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                                size="sm"
                            />
                        </div>
                    </b-col>
                    <!-- ./Search -->
                </b-row>
                <!-- ./Table Top -->
            </div>

            <!-- Table -->
            <b-table
                striped
                hover
                small
                ref="records"
                class="position-relative"
                :items="fetch"
                responsive
                :fields="columns"
                primary-key="id"
                :sort-by.sync="sortBy"
                show-empty
                empty-text="No records found"
                :sort-desc.sync="isSortDirDesc"
                sticky-header="640px"
            >

                <template #cell(user)="data">
                    <b-media vertical-align="center">
                        <template #aside>
                        <b-avatar
                            size="32"
                            :src="data.item.avatar"
                            :text="avatarText(data.item.fullName)"
                            :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
                        />
                        </template>
                        <b-link
                            :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
                            class="font-weight-bold d-block text-nowrap"
                        >
                        {{ data.item.person.firstName.trim().substring(0, 1).toUpperCase() + data.item.person.firstName.trim().substring(1).toLowerCase() }} {{ data.item.person.middleName? data.item.person.middleName.trim().substring(0, 1).toUpperCase() + data.item.person.middleName.trim().substring(1).toLowerCase() : '' }} {{ data.item.person.lastName.trim().substring(0, 1).toUpperCase() + data.item.person.lastName.trim().substring(1).toLowerCase() }}
                        </b-link>
                        <small class="text-muted">Phone: {{ data.item.mobile }}</small>
                    </b-media>
                </template>

                <template #cell(username)="data">
                    <span v-if="data.item.username">{{ data.item.username }}</span>
                    <span v-else>{{ data.item.email }}</span>
                </template>

                <template #cell(roles)="data">
                    <span v-if="data.item.roles && data.item.roles.length > 0">{{ data.item.roles[0].title }}</span>
                </template>

                <template #cell(station)="data">
                    <span v-if="!data.item.station">Unassigned</span>
                    <span v-else-if="data.item.station.station_type.toLowerCase().includes('location')">{{ data.item.station.station.name.toUpperCase() }}</span>
                    <span v-else-if="data.item.station.station_type.toLowerCase().includes('market')">{{ data.item.station.station.name.toUpperCase() }}</span>
                    <span v-else-if="data.item.station.station_type.toLowerCase().includes('warehouse')">{{ data.item.station.station.name.toUpperCase() }}</span>
                    <span v-else>Head Office</span>
                </template>

                <template #cell(forMarket)="data">
                    <span v-if="data.item.forMarket">Dot Matrix</span>
                    <span v-else>Normal Printer</span>
                </template>

                <template #cell(forDocument)="data">
                    <span v-if="data.item.forDocument">Sales Documents</span>
                    <span v-else>Online Tickets</span>
                </template>

                <!-- Column: Status -->
                <template #cell(status)="data">
                    <b-badge
                        pill
                        :variant="`light-${resolveStatusVariant(data.item.status)}`"
                        class="text-capitalize"
                    >
                        <span v-if="'' + data.item.status === '0'">Locked</span>
                        <span v-if="'' + data.item.status === '1'">Active</span>
                        <span v-if="'' + data.item.status === '-1'">Blocked</span>
                    </b-badge>
                </template>

                <template #cell(updated_at)="data">
                    {{ data.item.updated_at | moment('DD/MM/YYYY') }}
                </template>

                <!-- Column: Actions -->
                <template #cell(actions)="data">
                    <b-dropdown
                        variant="link"
                        no-caret
                        :right="$store.state.appConfig.isRTL"
                    >

                        <template #button-content>
                        <feather-icon
                            icon="MoreVerticalIcon"
                            size="16"
                            class="align-middle text-body"
                        />
                        </template>
        
                        <b-dropdown-item @click="invokeUpdateForm(data.item)">
                            <feather-icon icon="EditIcon" />
                            <span class="align-middle ml-50">Edit</span>
                        </b-dropdown-item>
        
                        <b-dropdown-item @click="remove(data.item.id)">
                            <feather-icon icon="TrashIcon" />
                            <span class="align-middle ml-50">Delete</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>

            <!-- Table Footer -->
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }} entries</span>
                    </b-col>
                    <!-- Pagination -->
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRecords"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>

        </b-card>
        <!-- ./Table Container Card -->
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
    BCard, BCardHeader, BCardBody,
    BRow, BCol,
    BForm, BFormGroup, BFormInput, BFormCheckbox,
    BDropdown, BDropdownItem, BButton, BFormSelect, BFormSelectOption,
    BTable, BPagination, BBadge, BMedia, BAvatar, BLink, BSpinner,
} from 'bootstrap-vue'
import LocationFilters from '@/@core/components/cromis/filters/LocationFilters'
import vSelect from 'vue-select'
import { avatarText } from '@core/utils/filter'
import { required } from '@validations'
import store from '@/store'
import { ref, onUnmounted, onMounted, computed } from '@vue/composition-api'
import printersStoreModule from '@/views/cromis/printer/printersStoreModule'
import usePrintersList from '@/views/cromis/printer/usePrintersList'
import moment from 'moment'
export default {
    props: {},
    components: {
        BCard, BCardHeader, BCardBody,
        BRow, BCol,
        BForm, BFormGroup, BFormInput, BFormCheckbox,
        BDropdown, BDropdownItem, vSelect, BButton, BFormSelect, BFormSelectOption,
        BTable, BPagination, BBadge, BMedia, BAvatar, BLink, BSpinner,
        ValidationProvider, ValidationObserver,
        LocationFilters,
    },
    directives: {},
    setup(props, context) {
        const saving = ref(false)
        const dataForm = ref(null)
        const serverErrors = ref(null)

        const markets  = ref([])
        const lines  = ref([])
        const warehouses  = ref([])

        const client = ref(JSON.parse(localStorage.getItem('userData')).client)

        const stations = ref([
            { station_type: 0, label: 'Head Office' },
            { station_type: 1, label: 'Location' },
            { station_type: 2, label: 'Market Center' },
            { station_type: 3, label: 'Warehouse' },
            { station_type: 4, label: 'Buying Line' },
        ])

        const printer = ref({
            id: null,
            name: null,
            model: null,
            address: null,
            forMarket: true,
            forDocument: true,
            station_type: 0,
            station_id: client.value.id,
        })

        const CROMIS_STORE_MODULE_NAME = 'cromis-printer'

        // Register module
        if (!store.hasModule(CROMIS_STORE_MODULE_NAME)) store.registerModule(CROMIS_STORE_MODULE_NAME, printersStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_STORE_MODULE_NAME)
        })

        onMounted(async () => {

        })

        const changeFilters = async (filteredLocation) => {
            if(printer.value.station_type == 1){
                printer.value.station_id = filteredLocation !== null? filteredLocation.id : null
            }
            else{
                markets.value.splice(0)
                warehouses.value.splice(0)

                if(filteredLocation !== null){
                    if(printer.value.station_type == 2 || printer.value.station_type == 4){
                        await store.dispatch('cromis-printer/markets', { location_id: filteredLocation.id})
                                .then(response => {
                                    markets.value = response.data.markets
                                })
                                .catch(error => {
                                    console.log('got error', error)
                                })
                    }
                }

                if(printer.value.station_type == 3){
                    await store.dispatch('cromis-printer/warehouses', { location_id: filteredLocation !== null? filteredLocation.id : null, main_store: 1 })
                            .then(response => {
                                warehouses.value = response.data.warehouses
                            })
                            .catch(error => {
                                console.log('got error', error)
                            })
                }
            }
        }

        const changeStationType = async (stationType) => {
            if(printer.value.station_type == false){
                printer.value.station_type = 0
                printer.value.station_id = client.value.id
            }
            else{
                if(printer.value.station_type == 0){
                    printer.value.station_id = client.value.id
                }
                else{
                    printer.value.station_id = null
                }
            }
        }

        const changeMarket = () => {
            if(printer.value.market_id !== null){
                markets.value.forEach((market) => {
                    if(market.id === printer.value.market_id){
                        lines.value = market.lines
                    }
                })
            }
            else{
                lines.value.splice(0)
            }
        }

        const {
            fetch,
            refetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,

            resolveStatusVariant,
        } = usePrintersList()

        // Form Methods
        const invokeUpdateForm = (item) => {
            printer.value = {
                id: item.id,
                name: item.name,
                model: item.model,
                address: item.address,
                forMarket: item.forMarket,
                forDocument: item.forDocument,
                station_type: item.station.type,
                station_id: item.station.station_id,
            }
        }

        const resetForm = () => {
            printer.value = {
                id: null,
                name: null,
                model: null,
                address: null,
                forMarket: true,
                forDocument: true,
                station_type: 0,
                station_id: client.value.id,
            }
        }

        const isFormValid = async () => {
            let isValid = false 
            await dataForm.value.validate().then(success => {
                isValid = success
            })

            return isValid
        }

        const submit = () => {
            serverErrors.value = null
            // Handle form submit
            if (printer.value.id === null || printer.value.id === 0)
                handleCreate()
            else
                handleUpdate(printer.value)
        }

        const handleCreate = async () => {
            saving.value = true
            const valid = await isFormValid()

            if(!valid){
                saving.value = false
                return
            }

            
            await store.dispatch('cromis-printer/create', printer.value)
                .then(response => {
                    refetch()
                    saving.value = false
                    resetForm()
                    
                    context.root.$swal({
                        icon: 'success',
                        text: `Printer has been registered successfully!`,
                        showConfirmButton: true,
                        timer: 5000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    console.log(error)
                    if(error.response.status === 422){
                        serverErrors.value = error.response.data.errors
                    }
                    else{
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handleUpdate = async (item) => {
            saving.value = true
            const valid = await isFormValid()

            if(!valid){
                saving.value = false
                return
            }

            await store.dispatch('cromis-printer/update', { id: printer.value.id, data: printer.value })
                .then(response => {
                    refetch()
                    saving.value = false

                    context.root.$swal({
                        icon: 'success',
                        text: `Changes to a printer has been made successfully!`,
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                    resetForm()
                })
                .catch(error => {
                    saving.value = false
                    resetForm()
                    console.log(error)
                    if(error.response.status === 422){
                        serverErrors.value = error.response.data.errors
                    }
                    else{
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const remove = async (id) => {
            await store.dispatch('cromis-printer/remove', id)
                        .then(response => {
                            refetch()
                        })
                        .catch(error => {
                            context.root.$swal({
                                icon: 'error',
                                title: 'Server Error',
                                text: 'Something went wrong. See tech support',
                                showConfirmButton: false,
                                customClass: {
                                    confirmButton: 'btn btn-danger',
                                },
                                buttonsStyling: false,
                            })
                        })
        }
        
        return {
            // Collections
            markets,
            warehouses,
            stations,
            lines,
            changeMarket,

            // Form
            client,
            dataForm,
            invokeUpdateForm,
            submit,
            saving,
            serverErrors,
            printer,
            changeFilters,
            changeStationType,
            remove,
            resetForm,

            // Validations
            required,
            avatarText,

            // Table
            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,
            resolveStatusVariant,
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>